import React, { useContext } from 'react'
import { Link } from 'react-router-dom';
import { DataContext } from '../../Context/Context'
import { Pagination, Navigation, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Container from '../../Container/Container'
import ProductCard from '../../ProductCardAll/ProductCard/ProductCard';
import "./SpecialOffer.css"

function SpecialOffer() {
    const value = useContext(DataContext);
    const [products, setProducts] = value.products;
    return (
        <>
            <Container class1='container-fluid  px-3 bg-danger bg-img-offer'>
                <div className="row rounded">
                    <div className="row ">
                        <div className="col-12 row text-white align-items-center py-3 titan-offer">
                            <div className="col-2 d-flex align-items-center">
                                <h3> پیشنهاد تایتان  </h3>
                            </div>
                            <div className="col-9">
                                <div className="line rounded"></div>
                            </div>
                            <div className="col-1 " >
                                <Link to='/store' className='text-white'>مشاهده همه </Link>
                            </div>

                        </div>
                    </div>
                    <div className="col-12">
                        <Swiper
                            slidesPerView={1}
                            breakpoints={{
                                500: { slidesPerView: 2},
                                768: { slidesPerView: 3 },
                                1000: { slidesPerView: 4 },
                                1200: { slidesPerView: 5 }
                            }}
                            spaceBetween={10}
                            freeMode={true}
                            navigation={true}
                            modules={[FreeMode, Pagination, Navigation]}
                            className="mySwiper"
                        >
                            {
                                products.map(product => (
                                    <SwiperSlide key={product._id}  >
                                        <ProductCard product={product} classes=' ' />
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                    </div>
                </div>

            </Container>
        </>
    )
}

export default SpecialOffer